import { handleActions } from 'redux-actions'
import * as type from './type'
import { LOCATION_CHANGE } from 'connected-react-router'
import { changeTableSettings, createInitialTableState } from '../../../form/state/table-state-helper'

export const initialState = {
    fetching: false,
    error: null,
    deleteFileConfirmationModalOpen: false,
    ...createInitialTableState({
        rowsPerPage: 20,
        sortColumnName: 'fileName',
        sortOrder: 1,
        rowsTotalOptions: [20, 40, 80, 200]
    }),
}


export default handleActions({
    [type.CHANGE_TABLE_SETTING]: changeTableSettings(),
    [LOCATION_CHANGE]: (state, action) => {
        return {
            ...initialState,
        }
    },
    [type.UPLOAD_CUSTOMER_FILE_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.UPLOAD_CUSTOMER_FILE_SUCCESS]: (state, action) => {
        return {
            ...state,
            fetching: false,
        }
    },
    [type.UPLOAD_CUSTOMER_FILE_ERROR]: (state, action) => {
        const { error } = action.payload

        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.SET_DELETE_FLAG_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.SET_DELETE_FLAG_SUCCESS]: (state, action) => {
        return {
            ...state,
            fetching: false,
        }
    },
    [type.SET_DELETE_FLAG_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            error,
            fetching: false,
        }
    },

}, initialState)



// WEBPACK FOOTER //
// ./src/modules/customer/state/cbct-file-upload/reducer.js